import { Button, Card, CardContent, InputText } from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { useForm, useWatch } from "react-hook-form";
import { ReactHookFormSwitch } from "../../../components/form/ReactHookFormSwitch";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { useSupplierAnnouncementCreate } from "../../../hooks/api/v2/supplierAnnouncement/useSupplierAnnouncementCreate";
import { useSupplierAnnouncementUpdate } from "../../../hooks/api/v2/supplierAnnouncement/useSupplierAnnouncementUpdate";

export const StorefrontSettingSupplierAnnouncementCard = ({
  supplier,
}: {
  supplier: SupplierGetResponseType;
}) => {
  const updateSupplierAnnouncementMutation = useSupplierAnnouncementUpdate(
    supplier.id,
    supplier.SupplierAnnouncement?.id ?? 0,
  );

  const createSupplierAnnouncementMutation = useSupplierAnnouncementCreate(
    supplier.id,
  );

  const { register, handleSubmit, control, formState } = useForm({
    defaultValues: {
      ctaLink: supplier.SupplierAnnouncement?.ctaLink,
      ctaLabel: supplier.SupplierAnnouncement?.ctaLabel,
      message: supplier.SupplierAnnouncement?.message,
      showAnnouncement: supplier.SupplierAnnouncement?.showAnnouncement,
    },
    shouldUseNativeValidation: true,
  });
  const ctaLabel = useWatch({
    control,
    name: "ctaLabel",
  });

  return (
    <Card className="bg-white">
      <CardContent className={"p-4"}>
        <form
          onSubmit={handleSubmit((data) => {
            if (!data.message) throw new Error("Need to define message");
            if (typeof data.showAnnouncement !== "boolean")
              throw new Error("showAnnouncement needs to be defined.");

            const mutation = supplier.SupplierAnnouncement
              ? updateSupplierAnnouncementMutation
              : createSupplierAnnouncementMutation;

            return mutation.mutate({
              ctaLink: data.ctaLink ?? null,
              ctaLabel: data.ctaLabel ?? null,
              message: data.message,
              showAnnouncement: data.showAnnouncement,
            });
          })}
          className={"flex flex-col gap-4"}
        >
          <div className={"flex justify-between"}>
            <InputLabel>Show announcement</InputLabel>
            <ReactHookFormSwitch
              {...register("showAnnouncement", { required: false })}
              control={control}
            />
          </div>
          <div className="">
            <InputLabel>Announcement</InputLabel>
            <InputContainer>
              <InputText {...register("message", { required: false })} />
            </InputContainer>
          </div>
          <div className="">
            <InputLabel>Button label</InputLabel>
            <InputContainer>
              <InputText {...register("ctaLabel", { required: false })} />
            </InputContainer>
          </div>
          <div className="">
            <InputLabel>Button URL</InputLabel>
            <InputContainer>
              <InputText {...register("ctaLink", { required: !!ctaLabel })} />
            </InputContainer>
          </div>
          <div className="flex justify-end">
            <Button
              className="flex justify-end"
              type={"submit"}
              loading={
                updateSupplierAnnouncementMutation.isPending ||
                createSupplierAnnouncementMutation.isPending
              }
              disabled={!formState.isDirty}
            >
              Save changes
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
